import React,{Component} from 'react';

import  { Form,Button } from 'react-bootstrap';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import actions from './../../store/Actions/index.js';

class ChangeName extends Component{
    state={
        newChapterName:""
    }
    onSubmit=async(evt) => {
        evt.preventDefault();
        await this.props.onChapterNameChange({reportId:this.props.reportId,sectionId:this.props.sectionId,chapterName:this.state.newChapterName});
        window.location.reload(true);
    }
    render(){
        return(
            <div>
                <Form onSubmit={this.onSubmit}>
                    <Form.Group>
                        <Form.Label>
                            New Name
                        </Form.Label>
                        <Form.Control type="text" placeholder="Add Chapter" required onChange={(evt) => {
                                this.setState({newChapterName:evt.target.value});
                            }}>
                        </Form.Control>
                    </Form.Group>
                    <Button varient="primary" type="submit">
                        Submit
                    </Button>
                </Form>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    changeName:state
});

const mapDispatchToProps = dispatch => ({
    onChapterNameChange:(v) => dispatch(actions.onChapterNameChange(v))
})

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(ChangeName));


// WEBPACK FOOTER //
// ./src/components/ChangeName/changeName.jsx